export class UpdateAdhocDDExtensionStatusDTO {
    Ids: number[];
    AdHocDueDateExtensionRequestStatusId: number;
}